import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
const IcoMapPinDefault = t0 => {
  const $ = _c(4);
  const {
    "aria-label": ariaLabel,
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M14.490 1.499 C 12.446 1.911,9.997 2.976,8.280 4.199 C 6.703 5.323,4.803 7.271,3.804 8.790 C 2.361 10.984,1.303 14.058,1.128 16.560 C 1.054 17.623,1.108 19.627,1.231 20.400 C 1.780 23.835,3.266 27.338,5.787 31.140 C 7.652 33.953,10.869 38.017,16.509 44.686 L 17.994 46.441 19.907 44.174 C 26.769 36.044,29.675 32.255,31.512 29.040 C 33.225 26.041,34.578 22.431,34.804 20.250 C 34.897 19.352,34.897 16.810,34.804 15.930 C 34.521 13.241,33.072 9.769,31.337 7.620 C 30.834 6.996,28.991 5.164,28.410 4.710 C 27.435 3.948,25.960 3.095,24.540 2.472 C 23.140 1.858,22.088 1.556,20.949 1.442 C 20.607 1.408,19.135 1.382,17.679 1.385 C 15.372 1.389,14.960 1.404,14.490 1.499" fill="#fff" stroke="none" fillRule="evenodd" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== ariaLabel || $[2] !== className) {
    t2 = <svg width={36} height={48} viewBox="0 0 36 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={true}>{t1}</svg>;
    $[1] = ariaLabel;
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default IcoMapPinDefault;